import React from "react";
import { ShieldAlert, XCircle } from "lucide-react";

interface User {
  email: string;
  impersonationMode?: boolean;
}

interface ImpersonationBannerProps {
  user: User | null;
  onExit: () => void;
}

/**
 * 🚩 IMPERSONATION BANNER: High-visibility safety indicator
 */
const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ user, onExit }) => {
  if (!user?.impersonationMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-red-600 text-white px-6 py-2.5 flex items-center justify-between shadow-2xl border-b border-white/10 overflow-hidden">
      {/* Animated background subtle pulse */}
      <div className="absolute inset-0 bg-white/5 animate-pulse" />
      
      <div className="flex items-center gap-4 relative z-10">
        <div className="p-1 bg-white/20 rounded-lg">
          <ShieldAlert size={18} className="text-white" />
        </div>
        <div>
          <span className="font-semibold text-[10px] block opacity-80 leading-none mb-1">
            Support Session Active
          </span>
          <span className="font-bold tracking-tight text-sm">
            Viewing society data as: <span className="underline decoration-white/30 underline-offset-4">{user.email}</span>
          </span>
        </div>
      </div>

      <button 
        onClick={onExit}
        className="relative z-10 flex items-center gap-2 bg-white text-red-600 px-5 py-2 rounded-xl text-xs font-semibold hover:bg-red-50 transition-all shadow-[0_4px_15px_rgba(255,255,255,0.2)] active:scale-95 group"
      >
        <XCircle size={14} className="group-hover:rotate-90 transition-transform duration-300" />
        Exit Session
      </button>
    </div>
  );
};

export default ImpersonationBanner;
